<template>
  <div class="contenedor-modal"
    v-bind:class="{'modal-abierto': abierto}"
    id="contenedor-modal"
  >
    <div class="modal-loader" v-if="cargando">
      <img src="@/assets/img/loader.svg" alt="Cargando...">
    </div>

    <div class="modal-cabecera" @click="abierto=false">
      <h2 class="titulo">
        Características del conglomerado {{cluster ? cluster.id : ""}}
      </h2>
      <span class="icono">»</span>
    </div>

    <div class="modal-cuerpo-conglomerados" :class="{'sin-subconglomerados' : subclusters.length == 0}">
      

      <div class="modal-contenedor-cluster" id="cluster"></div>

      <div class="modal-contenedor-controles">
        
        <div class="contenedor-resistencia">
          <h3>Resistencia</h3>
          <p>Tipo de antirretroviral al que presenta resistencia</p>
          <div v-for="(color, id) in dicColores" :key="id">
            <span class="indicador-color" 
              :style="`background-color:${color}`"
            ></span> {{id}}
          </div>
        </div>
        <hr/>
        <div class="contenedor-distancia-genetica">
          <h3>Distancia genética (%):</h3>
          <div v-for="(dist_gen) in cortes_distancias_geneticas" :key="dist_gen.id">
            <hr class="indicador-color-dg" 
              :style="`border-top: ${dist_gen.stroke_width} ${dist_gen.dash_array!='' ? 'dashed' : 'solid'} ${dist_gen.stroke_color}`"
            /> {{dist_gen.texto}}
          </div>
        </div>
        <hr>

        <ControlReproductor
          :arrange_fechas='listado_fechas'
          :fecha_min='fecha_min'
          :fecha_max='fecha_max'
        />
      </div>

      <div class="modal-contenedor-conglomerado">
        <h3 class="titulo-conglomerados">Miembros del conglomerado</h3>
        <div id="lista-conglomerado">
          <div class="item-conglomerado"
            v-for="(node, id) in (cluster!=undefined? cluster.nodes: [])"
            :key="id"
          >
            <span class="conglomerado-numero" :id="`item-conglomerado-${node.id}`"
              v-bind:class="{'hover-nodo': nodeOver===node.id}"
              :style="`background-color:${
                nodeOver===node.id? dicColores[node.resistencia]: '#fff'
              }`"
            >{{id + 1}}</span>

            <div class="conglomerado-detalles">
              <!--<b>Muestra: </b>{{node.id}}<br>-->
              <b>Fecha de toma: </b>{{node.fecha_toma}}<br>
              <b>Género: </b>{{node.sexo}}<br>
              <b>Edad: </b>{{node.edad}}<br>
              <b>Seguridad Social: </b>{{node.seguridad_social}}<br>
              <b>Carga viral: </b>{{node.CV}}<br>
              <b>Nivel de linfocitos: </b>{{node.cd4_a}}<br>
              <b>Resistencia: </b><b 
                :style="`color:${dicColores[node.resistencia]}`"
              >{{node.resistencia}}</b><br>
              <b>Ubicación: </b>{{node.municipio}}, {{node.estado}}<br>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ControlReproductor from '@/components/tablero-clusters/controles/Reproductor.vue';

import { mapGetters, mapState } from 'vuex';
import * as d3 from 'd3';

export default {
  components:{
    ControlReproductor
  },
  data() { return {
    dicColores: {},
    divCluster: undefined,
    cargando: true,
    cluster: undefined,
    nodeOver: undefined,
    subclusters: [],
    vista_cluster_seleccinada:"general",
    listado_fechas: [new Date()],
    fecha_min: new Date(),
    fecha_max: new Date(),
    cortes_distancias_geneticas: [],
    fuerza : d3.forceSimulation()
        .force('center', d3.forceCenter(0, 0))
        .force('charge', d3.forceManyBody().strength(-40))

  }},
  mounted() {
    this.parseDate = d3.timeParse("%Y-%m-%d");
    this.divCluster = document.getElementById('cluster');
  },
  watch: {
    categorias_distancias_geneticas(nv){
      this.cortes_distancias_geneticas = nv;
    },
    actualModalClusterDatos(nuevoValor) {
      if (nuevoValor != undefined) {
        this.bajarScroll(this.$el)
        this.cluster = {...nuevoValor};
        this.cluster_vis = JSON.parse(JSON.stringify(this.cluster))
        this.cluster_vis.nodes.forEach((d) => {
              delete d.vx;
              delete d.vy;
              delete d.x;
              delete d.y;
            }
          )
        this.cluster_vis.links.forEach((d) => {
              d.target = d.target.id;
              d.source = d.source.id;
            }
          )

        this.cluster_vis.nodes.forEach((d) => {
          d.date = this.parseDate(d.fecha_toma)
        })
        this.cluster_vis.links.forEach((d) => {
          d.date_target = this.parseDate(d.fecha_target);
          d.date_source = this.parseDate(d.fecha_source)
        })
        this.subclusters = [... new Set(this.cluster_vis.links.map((d) => d.subcluster_id))].filter((d => d));
        // Datos para el control temporal
        this.fechas_nodos = this.cluster_vis.nodes.map((d) => [d.fecha_toma,d.date]).sort((a, b) => a[1].getTime() - b[1].getTime())
        this.fecha_max = this.fechas_nodos.slice(-1)[0];
        this.fecha_min = this.fechas_nodos[1];
        this.listado_fechas = d3.timeDays(this.fecha_min[1], this.fecha_max[1],14);
        if(d3.max(this.listado_fechas) < this.fecha_max[1]){
          let date_max = new d3.max(this.listado_fechas)
          date_max.setDate(date_max.getDate() + 14 )
          this.listado_fechas.concat(date_max)
        }
        this.fecha_max = d3.max(this.listado_fechas);
        this.fecha_min = d3.min(this.listado_fechas);

        this.vista_cluster_seleccinada = "general";

        this.prepararEspacio()
      } else {
        this.cargando = true
      }
    },
    fecha_cluster_slider(nv){
      
      d3.selectAll(this.links._groups[0].filter(d => d.__data__.date_target > nv || d.__data__.date_source > nv))
        .style("stroke-opacity", "0")
      d3.selectAll(this.links._groups[0].filter(d => d.__data__.date_target <= nv && d.__data__.date_source <= nv))
        .transition()
        .duration(400)
        .style("stroke-opacity", "1")
      
      d3.selectAll(this.nodes._groups[0].filter(d => d.__data__.date > nv))
        .style("fill-opacity", "0")
      d3.selectAll(this.nodes._groups[0].filter(d => d.__data__.date <= nv))
        .transition()
        .duration(400)
        .style("fill-opacity", "1")

    },
    
    
  },
  methods: {
    prepararEspacio() {
      this.divCluster.innerHTML = '';
      //setTimeout(()=>{
        console.log('creando cluster', this.divCluster.clientWidth);
        this.dicColores = this.$store.getters.actualModalClusterColores
        this.crearCluster()
        this.cargando = false
      //},500)
    },
    crearCluster() {
      this.margen = {arriba: 30,
        abajo: 30,
        derecha: 30,
        izquierda: 30}
      this.width = this.divCluster.clientWidth - this.margen.derecha - this.margen.izquierda;
      this.height = this.divCluster.clientHeight - this.margen.abajo - this.margen.arriba;
      this.factor_distancia_links = .0015;
      this.esMovil = Boolean(window.innerWidth < 768);

      this.factorPantalla = this.esMovil? 2: 1; // 1 para lap y 2 para movil

      this.svg = d3.select('#cluster')
        .append('svg')
        .attr('width', this.width + this.margen.derecha + this.margen.izquierda)
        .attr('height', this.height + this.margen.abajo + this.margen.arriba)
      this.svg_grupo = this.svg.append('g')
        .attr('transform',`translate(${this.width * .5 + this.margen.izquierda},${this.height * .5 + this.margen.arriba})`)
      
      this.links = this.svg_grupo
        .selectAll('line.links-modal')
        .data(this.cluster_vis.links)
        .enter()
        .append('line')
        .attr("class","links-modal")
        .style('stroke', '#aaa')
        .style('stroke-width', (d) => {
          return this.cortes_distancias_geneticas.filter((dg) => (dg.rango[0] <= d.distancia && d.distancia < dg.rango[1]))[0].stroke_width;
        })
        .style('stroke', (d) => {
          return this.cortes_distancias_geneticas.filter((dg) => (dg.rango[0] <= d.distancia && d.distancia < dg.rango[1]))[0].stroke_color;
        } )
        .style('stroke-dasharray', (d) => {
          return this.cortes_distancias_geneticas.filter((dg) => (dg.rango[0] <= d.distancia && d.distancia < dg.rango[1]))[0].dash_array;
        } )

      this.nodes = this.svg_grupo
        .selectAll('g.nodos-modal')
        .data(this.cluster_vis.nodes)
        .enter()
        .append('g')
        .attr("class","nodos-modal")
      
      this.dimen = window.innerWidth > 768 ? 21 : 14;

      this.nodes.append("circle")
        .attr('r',this.dimen * .65)
        .style('fill', d => this.dicColores? 
          this.dicColores[d.resistencia]: '#000')
        .on('mouseover', (e, d) => {
          this.nodeOver = d.id
          this.scrollConglomerados(d.id)
        })
        .on('mouseout', () => {
          this.nodeOver = undefined
        })
      
      this.nodes
        .append('text')
        .attr('font-size', this.dimen)
        .style('fill', 'black')
        .style('font-weight', '600')
        .attr('font-family', 'Montserrat')
        .style('text-anchor', 'middle')
        .style("stroke","#fff")
        .style('alignment-baseline', 'text-after-edge')
        .text(d => d.index+1)
        .attr('x', this.dimen * Math.cos(2 * Math.PI * 1.5) )
        .attr('y',  this.dimen * Math.sin(2 * Math.PI * 1.5) )
      this.cluster_vis.nodes.forEach((d) => {
        d.x = 100 *d3.randomNormal(0,.2)();
        d.y = 100 * d3.randomNormal(0,.2)();
        d.vx = 0;
        d.vy = 0;
      })
      d3.forceSimulation(this.cluster_vis.nodes)
      .force('link', d3.forceLink()
          .id(d => d.id)
          .links(this.cluster_vis.links)
          .distance(  this.width  * this.height  * this.factor_distancia_links)
          .strength(0.1)
        )
        .force('center', d3.forceCenter(0, 0))
        .force('charge', d3.forceManyBody().strength(-4))
        .force('collision', d3.forceCollide().radius(this.dimen * 2 +1))
        .on('tick', this.ticked)
        
        

    },
    
    ticked(){
      this.links.attr('x1', d => d.source.x < .5 * this.width ? (d.source.x < .5 * -this.width ? .5 * -this.width : d.source.x): .5 * this.width)
        .attr('y1', d => d.source.y < .5 * this.height ? (d.source.y < .5 * -this.height ? .5 * -this.height : d.source.y): .5 * this.height)
        .attr('x2', d => d.target.x < .5 * this.width ? (d.target.x < .5 * -this.width ? .5 * -this.width : d.target.x): .5 * this.width)
        .attr('y2', d => d.target.y < .5 * this.height ? (d.target.y < .5 * -this.height ? .5 * -this.height : d.target.y): .5 * this.height)
      this.nodes.attr('transform', d => `translate(${
        d.x < .5 * this.width ? (d.x < .5 * -this.width ? .5 * -this.width : d.x): .5 * this.width},${
        d.y < .5 * this.height ? (d.y < .5 * -this.height ? .5 * -this.height : d.y): .5 * this.height})`);
  
    },
    bajarScroll(element, top=110) {
      window.scroll({
        behavior: 'smooth',
        left: 0,
        top: element.offsetTop - top,
      })
      console.log('down', (element.offsetTop - top));
    },
    scrollConglomerados(id, top=95) {
      document.getElementById('lista-conglomerado').scroll({
        behavior: 'smooth',
        left: 0,
        top: document.getElementById(`item-conglomerado-${id}`).offsetTop - top,
      })
    }
  },
  computed: {
    ...mapState(["fecha_cluster_slider","categorias_distancias_geneticas"]),
    ...mapGetters(['actualModalClusterDatos']),
    abierto: {
      get() {
        return this.$store.state.modalCluster.abierto
      },
      set(valor) {
        if (!valor) {
          this.$store.state.modalCluster.datos = undefined
        }
        this.$store.state.modalCluster.abierto = valor
      }
    },

  },
}
</script>

<style lang="scss">
$border-color: #333;
$padding: $gap * .5;
$alto-modal: 75vh;
$alto-modal-cabecera: 52px;

.contenedor-modal {
  background-color: white;
  border-radius: 10px;
  overflow: hidden;
  position: relative;
  max-height: 0;
  transition: all .5s ease-in-out;

  &.modal-abierto {
    max-height: none;
    border: 1px solid $border-color;
    margin-bottom: 30px;
    @media (min-width: map-get($media-queries-since, "md")) {
      max-height: $alto-modal;
    }
  }
}

.modal-cabecera {
  border-bottom: 1px solid $border-color;
  padding: $padding*.5 $padding;
  display: flex;
  justify-content: space-between;
  height: $alto-modal-cabecera;
  background-color: #1996FC;
  cursor: pointer;

  .titulo {
    font-size: 1em;
    line-height: 1.3em;
    margin: 0;
    color: white;
  }
  .icono {
    color: white;
    font-size: 1.5em;
    transform: rotate(-90deg);
  }
  @media (min-width: map-get($media-queries-since, "md")) {
    .titulo {
      font-size: 1.5em;
    }
  }
}
.contenedor-resistencia, .contenedor-distancia-genetica{
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-bottom: 15px;
  h3{
    width: 100%;
    margin-bottom: 10px;
  }
  p{
    margin: 0px 0 5px 0;
  }
  div{
    margin: 0;
    flex: 0 0 50%;
  }
}

.modal-cuerpo-conglomerados {
  display: grid;
  grid-template-areas:
    "subconglomerados"
    "cluster"
    "controles"
    "conglomerados";
  @media (min-width: map-get($media-queries-since, "md")) {
    grid-template-areas:
    "controles cluster conglomerados"
    "controles cluster conglomerados";
    &.sin-subconglomerados{
       grid-template-areas:
      "controles cluster conglomerados"
      "controles cluster conglomerados";

    }
    grid-template-columns: 1fr 2fr 1fr;
    max-height: calc(#{$alto-modal} - #{$alto-modal-cabecera});
  }
}
.modal-contenedor-subconglomerados {
  grid-area: subconglomerados;
  border-bottom: 1px solid black;
  padding-inline: 10px;
  @media (min-width: map-get($media-queries-since, "md")) {
    border-right: 1px solid black;
    border-bottom: none;
  }
}
.modal-contenedor-controles {
  font-size: 14px;
  grid-area: controles;
  padding-inline: 10px;
  margin-bottom: 10px;
  @media (min-width: map-get($media-queries-since, "md")) {
    border-right: 1px solid black;
    margin-bottom: 0px;
    grid-row-end: none;
  }
}
.modal-contenedor-cluster {
  grid-area: cluster;
  width: 100%;
  height: 300px;
  max-height: 300px;
  overflow: hidden;
  @media (min-width: map-get($media-queries-since, "md")) {
    height: calc(#{$alto-modal} - #{$alto-modal-cabecera});
    max-height: calc(#{$alto-modal} - #{$alto-modal-cabecera});
  }
}
.modal-contenedor-conglomerado {
  font-size: 14px;
  grid-area: conglomerados;
  border-top: 1px solid black;
  
  @media (min-width: map-get($media-queries-since, "md")) {
    border-left: 1px solid black;
    max-height: calc(#{$alto-modal} - #{$alto-modal-cabecera});
    border-top: none;
  }

  .titulo-conglomerados {
    border-bottom: 1px solid #8a8a8a;
    padding: 10px;
    margin: 0;
  }

  #lista-conglomerado {
    padding-inline: 10px;
    scrollbar-width: thin;
    scrollbar-color: #c0bbbc rgba(192,187,188,0.5);
    overflow-y: scroll;
    max-height: calc(#{$alto-modal} - #{$alto-modal-cabecera} - 45px);
    @media (max-width: map-get($media-queries-since, "md")) {
      max-height: calc(50vh - #{$alto-modal-cabecera} - 45px);
    }

    .item-conglomerado {
      display: flex;
      border-top: 1px solid #8a8a8a;
      &:first-child{
        border-top: none;
      }
      .conglomerado-numero {
        padding: 10px;
        width: 18%;
        max-width: 3rem;
        text-align: center;
        color: #555;
        transition: all .3s ease-in-out;
        
        &.hover-nodo {
          color: white;
          font-weight: bold;
          font-size: 16px;
          padding-top: 50px;
        }
      }
      .conglomerado-detalles {
        padding: 10px;
      }
    }
  }
}

.modal-loader {
  background: rgba(0, 0, 0, 0.2);
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 21;
  img {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
  }
}
hr {
  margin-block: auto !important;
}

.indicador-color {
  height: 20px;
  width: 20px;
  border-radius: 50%;
  border-color: #707070;
  display: inline-block;
  margin-right: 5px;
  border-width: 0.3px;
  margin-bottom: -2px;
  margin-top: 3px;
}
.indicador-color-dg{
  width: 40px;
  display: inline-block;
  margin:5px ;
  transform: translateY(-3px);
}
.listado-subclusters{
  margin: 15px 0;
  button{
    padding:0;
    display: block;
    font-weight: 400;
    font-size: 14px;
    margin-bottom: 5px;
    background: #fff;
    color: #000;
    text-decoration: underline;
    &.active{
      font-weight: bold;
      text-decoration: none;

    }
  }
}

svg {
  g {
    circle {
      cursor: pointer;
    }
  }
}
</style>
